module.exports = __webpack_public_path__ + "img/tweed_14_20_a.38606d7b.jpg";